<template>
  <div class="page_content">

    <form name="form" id="uploadCompetencyTreeForm" method="POST" enctype="multipart/form-data" v-on:submit.prevent>
        <div class="hidden-container">
            <input type="file" id="uploadCompetencyTreeFile" name="file" ref="fileInput" @change="fileToBeUploaded" />
        </div>
        <div class="row page-heading mx-0">
            <div class="col-8 input module_heading">
                <span class="module_icon icon-ic_ToC"></span>
                <span class="module_type_name">Competency Tree Management</span>
            </div>
            <div class="col-4 submit btn-container text-right">
                <button type="button" class="btn btn-primary" @click.prevent="cancel" aria-label="cancel">cancel</button>
                <button type="button" class="btn btn-primary" @click.prevent="upload" aria-label="upload" :disabled="!file">upload</button>
            </div>
        </div>
        <div>
            <b-row class="mt-5 upload-asset-section">
                <b-col cols="12" class="upload-asset-thru-csv pl-3 pr-3">
                    <div class="card">
                        <div class="heading">Upload Competency Tree thru a CSV File</div>
                        <div class="thumbnail-section">
                            <span class="icon-csvFile"></span>
                        </div>
                        <div class="card-body text-center">
                            <template v-if="file">
                                <span style="margin-top: -15px;">Chosen File: <strong>{{ file.name }}</strong></span>
                                <button type="button" class="btn btn-primary" @click.stop="chooseFile" aria-label="change CSV file" style="bottom: 40px !important;">change CSV file</button>
                            </template>
                            <template v-else>
                                <button type="button" class="btn btn-primary" @click.stop="chooseFile" aria-label="choose CSV file">choose CSV file</button>
                            </template>
                        </div>
                        <div class="sample-csv">
                            <a href="../../help/views/sampleFiles/competency_tree.csv" target="_blank" aria-label="click here to get a copy of the sample csv file.">Click here</a> to get a copy of the sample csv file.
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div>
            <b-modal class="competency-upload-exists-popup" ref="uploadErrorModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                <div class="text-center">
                    <span v-html="errorMessage"></span>
                </div>
              <div slot="modal-header" class="header-section">
                <div class="popup-heading">Error Message!</div>
                 <button class="btn_close" aria-label="close" @click="hideUploadErrorModal">
                     <span class="ic-close"></span>
                  </button>
              </div>
              <div slot="modal-footer" class="w-100">
                  <b-button @click="hideUploadErrorModal" class="btn button-primary float-right mr-2" aria-label="no"> ok </b-button>
              </div>
            </b-modal>
        </div>

        <div>
            <b-modal class="competency-upload-exists-popup" ref="competencyExistsModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                <div>
                    <span>{{ competencyExistsMessage }}</span>
                </div>
              <div slot="modal-header" class="header-section">
                <div class="popup-heading">Please Confirm!</div>
                 <button class="btn_close" aria-label="close" @click="hideConfirmBox">
                     <span class="ic-close"></span>
                  </button>
              </div>
              <div slot="modal-footer" class="w-100">
                  <b-button @click="uploadAndHideConfirmBox" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
                  <b-button @click="hideConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
              </div>
            </b-modal>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>

    </form>

  </div>
</template>

<script>
  import _ from 'lodash'
  import Papa from 'papaparse'
  import { mapActions } from 'vuex'

  var isCsvFile = function (file) {
    var fileName = file.name
    var regEx = /(.csv)$/i
    return regEx.test(fileName)
  }

  export default {
    name: 'competencyTreeUpload',
    data () {
      return {
        file: undefined,
        errorMessage: '',
        competencyExistsMessage: '',
        headers: ['format', 'code', 'displayTitleForStudent', 'displayTitleForTeacher', 'description']
      }
    },

    methods: {
      ...mapActions([
        'checkCompetency',
        'uploadCompetencyTree'
      ]),

      cancel () {
        return this.$router.push({name: 'competencyTreeList'})
      },

      chooseFile () {
        let sel = 'id=uploadCompetencyTreeFile'
        $('input[type=file][' + sel + ']').click()
      },

      fileToBeUploaded (ev) {
        let files = ev.target.files || ev.dataTransfer.files
        if (!files.length) {
          return
        }
        this.file = files[0]
      },

      readCsvFileAndShowWarningIfExists () {
        let self = this
        let reader = new FileReader()
        reader.onload = fileLoadedEvent => {
          Papa.parse(fileLoadedEvent.target.result, {
            header: true,
            skipEmptyLines: true,
            complete (results) {
              let plo = ''
              // let common = ''
              // let isInvalid = false
              // let isInvalidClo = false
              let missingHeaders = []
              let fields = (results.meta.fields.length > 0) ? _.map(results.meta.fields, (v) => { return v.toLowerCase() }) : []
              $.each(self.headers, (i, val) => {
                if (!_.includes(fields, val.toLowerCase())) {
                  if (missingHeaders.length === 0) {
                    missingHeaders.push(val)
                  } else {
                    missingHeaders.push(' ' + val)
                  }
                }
              })
              let isHeaderMissing = (missingHeaders.length > 0)
              /* let isHeaderMissing = _.some(self.headers, (val) => {
                return !_.includes(fields, val)
              }) */
              if (!isHeaderMissing) {
                if (results.data.length > 0) {
                  $.each(results.data, (i, data) => {
                    for (var attr in data) {
                      if (attr !== attr.toLowerCase()) {
                        data[attr.toLowerCase()] = data[attr]
                        delete data[attr]
                      }
                    }
                    let code = $.trim(data.code)
                    if (code) { /*
                      let codeArr = code.split('.')
                      let length = codeArr.length
                      let subject = (length > 1) ? codeArr[1] : codeArr[0]
                      if (i === 0) {
                        plo = data
                        common = subject
                        let prefix = codeArr[0]
                        if (prefix.toUpperCase() !== 'NU') {
                          self.errorMessage += '<strong>Row No. ' + (i + 2) + ': </strong> "' + code + '" is invalid code. Prefix must be "NU" and separated by dot(.)<BR><BR>'
                          isInvalid = true
                        }
                      } else if (!isInvalid) {
                        if (common.toUpperCase() !== subject.toUpperCase()) {
                          self.errorMessage += '<strong>Row No. ' + (i + 2) + ': </strong> "' + code + '" is invalid code. It must start with "' + plo.code + '".<BR><BR>'
                          isInvalidClo = true
                        }
                        if (!isInvalidClo) {
                          let lastPart = (length > 1) ? codeArr[length - 1] : codeArr[0]
                          switch (length) {
                            case 3:
                              sessionStorage.clear()
                              if ((lastPart.length === 1 || lastPart.indexOf('C') !== 0) || isNaN(lastPart.substr(1, 1)) || isNaN(lastPart.substr(-1))) {
                                self.errorMessage += '<strong>Row No. ' + (i + 2) + ': </strong> "' + code + '" is invalid code. Format should be "' + plo.code + '.CXX" (XX is the order number).<BR><BR>'
                              } else {
                                sessionStorage.setItem('cloCode', code)
                              }
                              break
                            case 4:
                              let cloCode = sessionStorage.getItem('cloCode')
                              if ((lastPart.length === 2 || lastPart.indexOf('MC') !== 0) || isNaN(lastPart.substr(2, 1)) || isNaN(lastPart.substr(-1))) {
                                if (cloCode) {
                                  self.errorMessage += '<strong>Row No. ' + (i + 2) + ': </strong> "' + code + '" is invalid Code. Format should be "' + cloCode + '.MCXX" (XX is the order number).<BR><BR>'
                                } else {
                                  self.errorMessage += '<strong>Row No. ' + (i + 2) + ': </strong> "' + code + '" is invalid Code. Format should be "' + plo.code + '.CXX.MCXX" (XX is the order number).<BR><BR>'
                                }
                              } else {
                                if (cloCode && code.indexOf(cloCode + '.') !== 0) {
                                  self.errorMessage += '<strong>Row No. ' + (i + 2) + ': </strong> "' + code + '" is invalid Code. Format should be "' + cloCode + '.MCXX" (XX is the order number).<BR><BR>'
                                }
                              }
                              break
                          }
                        }
                      }
                      let titleMessage = ''
                      if (!data.displaytitleforstudent || $.trim(data.displaytitleforstudent).length === 0) {
                        titleMessage = '"displayTitleForStudent"'
                      }
                      if (!data.displaytitleforteacher || $.trim(data.displaytitleforteacher).length === 0) {
                        titleMessage += (titleMessage.length > 0) ? ' and "displayTitleForTeacher"' : '"displayTitleForTeacher"'
                      }
                      if (titleMessage.length > 0) {
                        self.errorMessage += '<strong>Row No. ' + (i + 2) + ': </strong> ' + titleMessage + ' can not be left blank.<BR><BR>'
                      }
                      if (!data.description || $.trim(data.description).length === 0) {
                        self.errorMessage += '<strong>Row No. ' + (i + 2) + ': </strong> "description" can not be left blank.<BR><BR>'
                      }
                      if (!data.format || $.trim(data.format).length === 0) {
                        self.errorMessage += '<strong>Row No. ' + (i + 2) + ': </strong> "format" can not be left blank.<BR><BR>'
                      }
                    */ } else {
                      self.errorMessage += '<strong>Row No. ' + (i + 2) + ': </strong> "code" can not be left blank.<BR><BR>'
                      /* if (i === 0) {
                        isInvalid = true
                      } */
                    }
                  })
                } else {
                  self.errorMessage += 'No data found. '
                }
              } else {
                self.errorMessage += 'Headers <strong>[' + missingHeaders + ']</strong> are missing.<BR><BR>'
              }
              if (self.errorMessage.length > 0) {
                self.errorMessage += 'Please fix the error and re-upload.'
                self.$refs.uploadErrorModal.show()
              } else {
                self.checkCompetency(plo.code).then(res => {
                  if (res) {
                    self.$refs.loadingModal.hide()
                    let title = plo.displaytitleforteacher
                    self.competencyExistsMessage = '"' + title + '" competency tree already exists. Uploading will update the competency tree. Are you sure you want upload?'
                    self.$refs.competencyExistsModal.show()
                  } else {
                    let data = new FormData()
                    data.append($('#uploadCompetencyTreeFile').attr('name'), self.file, self.file.name)
                    self.uploadCompetencyTree({data: data, success: self.success, error: self.error})
                  }
                })
              }
            },
            error (errors) {
              console.log('error: ', errors)
            }
          })
        }
        reader.readAsText(this.file)
      },

      hideUploadErrorModal () {
        this.$refs.uploadErrorModal.hide()
        this.errorMessage = ''
        this.file = undefined
        this.clearFilePath()
        sessionStorage.clear()
      },

      upload () {
        if (isCsvFile(this.file)) {
          this.$refs.loadingModal.show()
          this.readCsvFileAndShowWarningIfExists()
        } else {
          this.clearFilePath()
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Please select a CSV file'
          })
        }
      },

      success (data) {
        console.log('data: ', data)
        if (data.errorCount === -1) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: '<textarea readonly style="background: #ffb648; border: 0px !important;" rows="5" cols="40">' + data.insight + '</textarea>'
          })
          this.$refs.loadingModal.hide()
        } else {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Upload and processing of ' + data.fileName + ' completed successfully.'
          })
          setTimeout(() => {
            if (data.insight && data.insight.length > 0) {
              this.$notify({
                group: 'notify',
                type: 'warn',
                title: '',
                text: '<textarea readonly style="background: #ffb648; border: 0px !important;" rows="5" cols="40">' + data.insight + '</textarea>'
              })
            }
            this.$refs.loadingModal.hide()
            return this.$router.push({name: 'competencyTreeList'})
          }, 500)
        }
      },

      error (err) {
        console.log('err: ', err)
        this.clearFilePath()
        this.$refs.loadingModal.hide()
      },

      clearFilePath () {
        const input = this.$refs.fileInput
        input.type = 'text'
        input.type = 'file'
      },

      uploadAndHideConfirmBox () {
        this.$refs.competencyExistsModal.hide()
        this.$refs.loadingModal.show()
        let data = new FormData()
        data.append($('#uploadCompetencyTreeFile').attr('name'), this.file, this.file.name)
        this.uploadCompetencyTree({data: data, success: this.success, error: this.error})
      },

      hideConfirmBox () {
        this.clearFilePath()
        this.file = undefined
        this.competencyExistsMessage = ''
        this.$refs.competencyExistsModal.hide()
        return this.$router.push({name: 'competencyTreeList'})
      }
    }
  }
</script>

<style scoped>
    .hidden-container{
        visibility: hidden;
        height: 1px;
    }

    .card {
        height: 345px;
        border: 0;
        background: #f5f5f5;
        box-shadow: 2px 1px 6px 0px #b9b9b9;
        border-radius: 0;
        position:relative;
    }

    .card-body {
        margin-top: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/app/course/components/CompetencyTreeUpload.vue